<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!-- <el-button type="primary" @click="startCreate()" size="mini">新建通知公告</el-button> -->
      </div>


      <el-radio-group size="mini" v-model="relateType">
        <el-radio-button label="0">我发布的</el-radio-button>
        <el-radio-button label="1">我接收的</el-radio-button>
      </el-radio-group>
      <!-- <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select> -->
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="title" width="200" label="标题"></el-table-column>
      <el-table-column prop="content" label="内容"></el-table-column>
      <el-table-column label="操作" width="120px" align="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="通知公告详情" placement="bottom">
            <i class="iconfont icon-157 meeting-btn-icon mbi-detail" @click="NoticeDetail(scope.row)"></i>
          </el-tooltip>

          <span v-if="scope.row.creator.id==userData.id">
            <el-tooltip v-if="scope.row.status!='进行中' && scope.row.status!='已结束'" class="item" effect="dark"
              content="修改通知公告" placement="bottom">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="EditNotice(scope.row)"></i>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status!='进行中' && scope.row.status!='已结束'" class="item" effect="dark"
              content="撤销通知公告" placement="bottom">
              <i class="iconfont icon-close meeting-btn-icon mbi-remove"
                @click="setNoticeState(scope.row, 'cancle')"></i>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 通知公告详情 -->
    <notice-detail :noticeStatus="noticeStatus" v-on:hideNoticeDetail="hideNoticeDetail" :noticeDetail="noticeDetail"
      :isManager="isManager"></notice-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'

  import NoticeDetail from './components/noticeDetail'
  export default {
    components: {
      UserInfo,
      NoticeDetail
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 详情
        noticeStatus: false,
        noticeDetail: '',
        isManager: true,

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表类型 0：我发布的  1：我接收的
        relateType: "0",
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      if (!this.userData) {
        return false
      }

      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      this.getLists()
    },
    methods: {
      // 通知公告详情
      NoticeDetail(row) {
        this.noticeStatus = true
        ajax.get('/notice/info/' + row.id, "", (res) => {
          this.noticeDetail = res.vo
        })
      },
      hideNoticeDetail() {
        this.noticeStatus = false
        this.noticeDetail = ""
      },
      // 编辑通知公告
      EditNotice(row) {
        this.$router.push('/Notice/Create/' + row.id)
      },
      // 取消、结束通知公告
      setNoticeState(row, type) {
        switch (type) {
          case 'cancle':
            this.$confirm('此操作将会撤销通知公告，操作结果不可逆，请你确认是否撤销通知公告?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              ajax.post('/notice/del', {
                noticeId: row.id,
              }, (res) => {
                this.$message.success("撤销通知公告成功")
                this.getLists()
              })
            }).catch(() => {});
            break;
          case 'end':
            this.showNoticeSumary(row.id)
            break;
        }
      },
      startCreate() {
        this.$router.push("/Notice/Create")
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/notice/relate/list', {
          type: this.relateType
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'relateType'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/notice/myList.vue